import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import {AccountBalanceWallet,
  LastPage,
  AllInclusive,
  Add,
  MoreVert,
  Schedule,
  Block,
  Subway,
  AirportShuttle,
  Edit,
  Delete,
  Done,
  Image,
  Settings,
  ArrowForwardIos,
  Inbox,
  AccountCircle,
  EmojiTransportation,
  ImportantDevices,
  AccountCircleOutlined,
  Close,
  PhoneAndroid,
  AlternateEmail,
  SettingsInputSvideo,
  EditOutlined,
  LocalTaxiOutlined,
  AccountBalance,
  LocalMall,
  ConfirmationNumber
} from "@material-ui/icons";

import DateFnsUtils from "@date-io/date-fns";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,DatePicker
} from "@material-ui/pickers";

import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  Grid,
  List,ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  CircularProgress,
  FormHelperText,Stepper,Step,StepLabel,ListItemIcon,Divider,
  ListItemSecondaryAction
} from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import UserInfo from "./login_info";

import { useSnackbar } from 'notistack';

import axios from 'axios';

import {TransportService,AdminService} from "./../../utils/web_config_2";

import {useHistory } from "react-router-dom";

import Isettings from "../../assets/svg/settings.svg";

import Format from "date-fns/format";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  type_list:{
    backgroundColor: theme.palette.background.paper,
  },
  btn: {
    textTransform: "capitalize",
    margin:theme.spacing(1)
  },
  formTitle: {
    flexGrow: 1,
  },
  list:{
      width:"100%"
  }
}));

function SettingsManager() {
  const classes = useStyles1();
  const [message,setMessage]=useState("Loading...");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [operatorData, setOperatorData] = useState({});
  const [transportData,setTransportData]=useState({});
  const [operatorAgent,setOperatorAgent]=useState({});
  
  const history = useHistory();

  
   useEffect(()=>{
    var data = {};
    const data1 = localStorage.getItem("nx_op");
    console.log("data1");
    console.log(data1);
    if (data1 != null) {
      data = JSON.parse(data1);
      userMustChangePassword(data);
    }
    console.log("data");
    console.log(data);
    setOperatorData(data);
    axios.defaults.baseURL = new AdminService().BASE_URL;

    const dataTransport = JSON.parse(localStorage.getItem("profile"));
    setTransportData(dataTransport);

    const oAgent=JSON.parse(localStorage.getItem("operatorAgent"));
    setOperatorAgent(oAgent);

    

   },[]);


   const userMustChangePassword=(userData)=>{
    if(userData.user_must_change_password===true){
      setOpen("profile");
      setChangeDialog(true);
    }

  }


   // open 

   const [open,setOpen]=useState("");
   

  //  change password dialog
  
  const [changeDialog,setChangeDialog]=useState(false);

  const [changePasswordDialog,setChangePasswordDialog]=useState(false);
  const [newPassword,setNewPassword]=useState({value:"",error:""});
  const [oldPassword,setOldPassword]=useState({value:"",error:""});

  const [changeLoad,setChangeLoad]=useState(false);

  const change_password=()=>{
    if(oldPassword.value==""){
      setOldPassword({value:"",error:"Enter valid password"});
    }else if(newPassword.value==""){
      setNewPassword({value:"",error:"Enter valid password"});
    }else{
      setChangeLoad(true);
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const changeInstance = axios.create(new AdminService().setHeaders(operatorData.token));
      changeInstance.put('/api/v1/user/changePassword',{
        "new_password": newPassword.value,
        "old_password": oldPassword.value
      })
      .then(res=>{
        enqueueSnackbar("Password changed successful!", { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      setChangeDialog(false);
      setChangeLoad(false);
      })
      .catch(err=>{
        setChangeLoad(false);
        if(err.response){
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      });
    }
    
  }


  // chnage luggage price per km


  const [priceDialog,setPriceDialog]=useState(false);
  const [priceLoad,setPriceLoad]=useState(false);

  const [luggagePrice,setLuggagePrice]=useState({value:0,error:""});


  const save_luggage_price=()=>{

    setPriceLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
      const changeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      changeInstance.put('/api/v1/integrations/modifyOrganization',
      {
        "admin_id": transportData.operator.admin_id,
        "booking_limit": transportData.operator.booking_limit,
        "email": transportData.operator.email,
        "id": transportData.operator.id,
        "logo_url":transportData.operator.logoUrl,
        "luggage_kg_cost_per_km": luggagePrice.value,
        "max_promotion_ticket_counter": transportData.operator.max_promotion_ticket_counter,
        "names": transportData.operator.names,
        "organization_id": transportData.operator.id,
        "organization_type": transportData.operator.organization_type,
        "phone_number": transportData.operator.phone_number,
        "status": transportData.operator.status,
        "tin_number": transportData.operator.tin_number
      })
      .then(res=>{
        enqueueSnackbar("Luggage price changed successful!", { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });

      // update states
      var tData=transportData;
      tData.operator.luggage_kg_cost_per_km=parseInt(luggagePrice.value);
      setTransportData(tData);
      console.log(tData);
      // update local storage profile  from transport
      localStorage.removeItem("profile");
      localStorage.setItem("profile",JSON.stringify(tData));
      setPriceDialog(false);
      setPriceLoad(false);
      })
      .catch(err=>{
        setPriceLoad(false);
        if(err.response){
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      });

  }



  // change max promotion tickets


  const [maxDialog,setMaxDialog]=useState(false);
  const [maxLoad,setMaxLoad]=useState(false);

  const [maxTickets,setMaxTixkets]=useState({value:0,error:""});


  const chane_max_tickets=()=>{
    setMaxLoad(true);
axios.defaults.baseURL = new TransportService().BASE_URL;
      const changeInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      changeInstance.put('/api/v1/integrations/modifyOrganization',
      {
        "admin_id": transportData.operator.admin_id,
        "booking_limit": transportData.operator.booking_limit,
        "email": transportData.operator.email,
        "id": transportData.operator.id,
        "logo_url":transportData.operator.logoUrl,
        "luggage_kg_cost_per_km":transportData.operator.luggage_kg_cost_per_km,
        "max_promotion_ticket_counter": maxTickets.value,
        "names": transportData.operator.names,
        "organization_id": transportData.operator.id,
        "organization_type": transportData.operator.organization_type,
        "phone_number": transportData.operator.phone_number,
        "status": transportData.operator.status,
        "tin_number": transportData.operator.tin_number
      })
      .then(res=>{
        enqueueSnackbar("Max Promotion tickets changed!", { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });

      // update states
      var tData=transportData;
      tData.operator.max_promotion_ticket_counter=parseInt(maxTickets.value);
      setTransportData(tData);
      console.log(tData);
      // update local storage profile  from transport
      localStorage.removeItem("profile");
      localStorage.setItem("profile",JSON.stringify(tData));
      setMaxDialog(false);
      setMaxLoad(false);

      })
      .catch(err=>{
        setMaxLoad(false);
        if(err.response){
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      });

  }


  return (
    <div className={classes.root}>

     <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}> <Settings fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Settings</b></Typography>

 </Box>
 

 
     </Box>



<Grid container>
<Grid md={6} xs={12} lg={6}>

  <Box mt={1} mr={1}>
   
  <Paper elevation={0}>
  <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.list}
    >

        <Box mt={1}>
        <Paper elevation={0}>
        <ListItem className={classes.list}  button onClick={()=>{
setOpen("profile");
}}>
  <ListItemIcon>
    <AccountCircleOutlined fontSize="large"/>
  </ListItemIcon>
  <ListItemText primary="Profile" />
  <ArrowForwardIos />
</ListItem>
            </Paper>

        </Box>
     
      
        {/* <Box mt={1}>
        <Paper elevation={0}>
        <ListItem className={classes.list}  button onClick={()=>{
          setOpen("operator");
        }}>
  <ListItemIcon>
    <EmojiTransportation fontSize="large"/>
  </ListItemIcon>
  <ListItemText primary="Organization" />
  <ArrowForwardIos />
</ListItem>
            </Paper>

        </Box> */}

        <Box mt={1}>
        <Paper elevation={0}>
        <ListItem className={classes.list}  button onClick={()=>{

}}>
  <ListItemIcon>
    <ImportantDevices fontSize="large"/>
  </ListItemIcon>
  <ListItemText primary="Appearance" />
  <ArrowForwardIos />
</ListItem>
            </Paper>

        </Box>


        
    </List>
  </Paper>
  
  </Box>
   </Grid>
  <Grid md={6} xs={12} lg={6}>
  <Box mt={1}>
    {open==""&&
    <Box>
    <Box display="flex"  justifyContent="center">
      <img src={Isettings} style={{flexGrow:1}} height="220px" />
      </Box>
      <Box display="flex" justifyContent="center"><Typography>Select specific settings</Typography></Box>
      </Box>}
  {open=="profile"&&
  <Paper elevation={0}>
<Box p={1}>
  <Grid container>
    <Grid item xs={6} md={6} lg={6} sm={6}>
    <Box display="flex" justifyContent="flex-start">
    <Typography>Profile</Typography>
    </Box>
    </Grid>
    <Grid item xs={6} md={6} lg={6} sm={6}>
      <Box display="flex" justifyContent="flex-end">
      <IconButton onClick={()=>{
        setOpen("");
      }}>
  <Close/>
</IconButton>
      </Box>
    </Grid>


<Grid item xs={12} md={12} lg={12} sm={12}>
  <Box display="flex" justifyContent="center">
    <AccountCircleOutlined color="secondary" style={{width:"100px",height:"100px"}}/>
  </Box>
  <Box display="flex" justifyContent="center">
  {operatorData.first_name+" "+operatorData.last_name}
  </Box>
  <Box style={{width:"100%"}} display="flex" justifyItems="center">
  <List style={{width:"100%"}}>
        <ListItem>
    <ListItemText primary={operatorData.role_name}/>
    <ListItemSecondaryAction>
                      <SettingsInputSvideo/>
                  </ListItemSecondaryAction>
        </ListItem>

        <ListItem>
          <ListItemText primary={operatorData.phone_number} />
          <ListItemSecondaryAction>
                      <PhoneAndroid/>
                  </ListItemSecondaryAction>
        </ListItem>

        <ListItem>
          <ListItemText primary={operatorData.email} />
          <ListItemSecondaryAction>
                      <AlternateEmail/>
                  </ListItemSecondaryAction>
        </ListItem>
        <ListItem>
          <ListItemText primary={"********"} />
          <ListItemSecondaryAction>
            <IconButton onClick={()=>{
               setChangeDialog(true);
            }}>
            <EditOutlined/>
            </IconButton>
                      
                  </ListItemSecondaryAction>
        </ListItem>
      </List>

      
  </Box>
</Grid>

  </Grid>

</Box>
  </Paper>
}

{open=="operator"&&
   <Paper elevation={0}>
   <Box p={1}>
     <Grid container>
       <Grid item xs={6} md={6} lg={6} sm={6}>
       <Box display="flex" justifyContent="flex-start">
       <Typography>Operator</Typography>
       </Box>
       </Grid>
       <Grid item xs={6} md={6} lg={6} sm={6}>
         <Box display="flex" justifyContent="flex-end">
         <IconButton onClick={()=>{
           setOpen("");
         }}>
     <Close/>
   </IconButton>
         </Box>
       </Grid>
   
   
   <Grid item xs={12} md={12} lg={12} sm={12}>
     <Box display="flex" justifyContent="center">
       <LocalTaxiOutlined color="secondary" style={{width:"100px",height:"100px"}}/>
     </Box>
     <Box display="flex" justifyContent="center">
     {operatorData.organization.name+"("+operatorData.organization.shortName+")"}
     </Box>
     <Box style={{width:"100%"}} display="flex" justifyItems="center">
     <List style={{width:"100%"}}>
           <ListItem>
       <ListItemText primary={operatorData.organization.organization_type}/>
       <ListItemSecondaryAction>
                         <SettingsInputSvideo/>
                     </ListItemSecondaryAction>
           </ListItem>
   
           <ListItem>
             <ListItemText primary={operatorData.organization.tin_number} />
             <ListItemSecondaryAction>
                         <PhoneAndroid/>
                     </ListItemSecondaryAction>
           </ListItem>
           <ListItem>
             <ListItemText primary={operatorData.organization.settlement_bank_account} />
             <ListItemSecondaryAction>
               <AccountBalance/>
                     </ListItemSecondaryAction>
           </ListItem>   

           <ListItem>
             <ListItemText primary={operatorAgent.agent_code} />
             <ListItemSecondaryAction>
               <AccountBalanceWallet/>
                     </ListItemSecondaryAction>
           </ListItem> 

           <ListItem>
           <ListItemIcon>
            <LocalMall/>
          </ListItemIcon>
             <ListItemText primary={"Luggage Pirce Per KG: "+transportData.operator.luggage_kg_cost_per_km+"  "} />
             <ListItemSecondaryAction>
             <IconButton color="primary" aria-label="upload picture" component="span" onClick={()=>{
               setLuggagePrice({value:transportData.operator.luggage_kg_cost_per_km,error:""});
                setPriceDialog(true);
             }}>
                <Edit/>
                </IconButton>
                     </ListItemSecondaryAction>
           </ListItem>

           <ListItem>
           <ListItemIcon>
            <ConfirmationNumber/>
          </ListItemIcon>
             <ListItemText primary={"Max Promotion Tickets: "+transportData.operator.max_promotion_ticket_counter+" Tickets"} />
             <ListItemSecondaryAction>
             <IconButton color="primary" aria-label="upload picture" component="span" onClick={()=>{
               setMaxTixkets({value:transportData.operator.max_promotion_ticket_counter,error:""});
               setMaxDialog(true);
             }}>
                <Edit/>
                </IconButton>
                     </ListItemSecondaryAction>
           </ListItem>

         </List>
   
         
     </Box>
   </Grid>
   
     </Grid>
   
   </Box>
     </Paper>
   
}

 
</Box> 
  </Grid>
</Grid>



{/* change password  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={changeDialog}
        onClose={()=>{

         setChangeDialog(false);

        }}
        aria-labelledby="change_password"
        aria-describedby="change_password"
      >
        <DialogTitle id="change_password">{"Change Password"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' type="password" variant='outlined' label={"Old Password"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setOldPassword({value:"",error:"Enter valid password"})
                 }else{
                   setOldPassword({value:e.target.value,error:""});
                 }
               }} 
               error={oldPassword.error!==""}
               helperText={oldPassword.error}/>
              </Box>


              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' type="password" variant='outlined' label={"New Password"} fullWidth
               onChange={(e)=>{
                 if(e.target.value===""){
                   setNewPassword({value:"",error:"Enter valid New password"})
                 }else{
                   setNewPassword({value:e.target.value,error:""});
                 }
               }} 
               error={newPassword.error!==""}
               helperText={newPassword.error}/>
              </Box>

        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
            
         setChangeDialog(false);

          }} color="secondary" variant="outlined" >
            close
          </Button>

          <Button color="primary" onClick={()=>{
            
            change_password();

             }}  variant="contained" >
              {changeLoad?<CircularProgress size={25} color="secondary"/>:"Save"} 
             </Button>
         
        </DialogActions>
      </Dialog>



 {/* change luggage price per km */}




      <Dialog
    maxWidth="sm"
    fullWidth
        open={priceDialog}
        onClose={()=>{

         setPriceDialog(false);

        }}
        aria-labelledby="change_luggage_price"
        aria-describedby="change_luggage_price"
      >
        <DialogTitle id="change_luggage_price">{"Change Luggae Price"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' type="number" variant='outlined' label={"Luggage price"} fullWidth
               value={luggagePrice.value}
               onChange={(e)=>{
                 if(e.target.value===0){
                   setLuggagePrice({value:"",error:"Enter valid price"})
                 }else{
                  setLuggagePrice({value:e.target.value,error:""});
                 }
               }} 
               error={luggagePrice.error!==""}
               helperText={luggagePrice.error}/>
              </Box>
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
         setPriceDialog(false);
          }} color="secondary" variant="outlined" >
            close
          </Button>

          <Button color="primary" onClick={()=>{
            save_luggage_price();
             }}  variant="contained" >
              {priceLoad?<CircularProgress size={25} color="secondary"/>:"Save"} 
             </Button>
         
        </DialogActions>
      </Dialog>



{/* change max promotion tickets */}



      <Dialog
    maxWidth="sm"
    fullWidth
        open={maxDialog}
        onClose={()=>{

         setMaxDialog(false);

        }}
        aria-labelledby="change_max_promotion"
        aria-describedby="change_max_promotion"
      >
        <DialogTitle id="change_max_promotion">{"Change Maximum Promotion tickets"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
          <Box display='flex' alignItems='center' justifyContent='center'>
               <TextField size='small' type="number" variant='outlined' label={"Tickets"} fullWidth
               value={maxTickets.value}
               onChange={(e)=>{
                 if(e.target.value===0){
                   setMaxTixkets({value:"",error:"Enter valid number"})
                 }else{
                  setMaxTixkets({value:e.target.value,error:""});
                 }
               }} 
               error={maxTickets.error!==""}
               helperText={maxTickets.error}/>
              </Box>
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
         setMaxDialog(false);
          }} color="secondary" variant="outlined" >
            close
          </Button>

          <Button color="primary" onClick={()=>{
            chane_max_tickets();
             }}  variant="contained" >
              {maxLoad?<CircularProgress size={25} color="secondary"/>:"Save"} 
             </Button>
         
        </DialogActions>
      </Dialog>




    </div>
  );
}

export default withLocalize(SettingsManager);
